import { Component, inject, ChangeDetectionStrategy } from "@angular/core";
import { NotificationService } from "../../../services/notification.service";
import { UserService } from "../../../services/user.service";
import {
	MatDialogRef,
	MatDialogTitle,
	MatDialogContent,
	MatDialogActions,
	MatDialogClose,
} from "@angular/material/dialog";
import { finalize, first } from "rxjs";
import { MatProgressSpinner } from "@angular/material/progress-spinner";

import { MatButton } from "@angular/material/button";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { NgxMaskDirective } from "ngx-mask";
import { MatInput } from "@angular/material/input";
import { MatFormField, MatLabel } from "@angular/material/form-field";
import { TranslatePipe, TranslateService } from "@tolgee/ngx";
import { MatIcon } from "@angular/material/icon";
import { MatMenu, MatMenuItem, MatMenuTrigger } from "@angular/material/menu";

@Component({
	selector: "app-mfacode",
	templateUrl: "./mfacode.component.html",
	styleUrls: ["./mfacode.component.scss"],
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [
		MatDialogTitle,
		MatDialogContent,
		MatFormField,
		MatLabel,
		MatInput,
		NgxMaskDirective,
		ReactiveFormsModule,
		FormsModule,
		MatDialogActions,
		MatButton,
		MatDialogClose,
		MatProgressSpinner,
		TranslatePipe,
		MatIcon,
		MatMenu,
		MatMenuItem,
		MatMenuTrigger,
	],
})
export class MFACodeComponent {
	private toastr = inject(NotificationService);
	private translate = inject(TranslateService);
	private userService = inject(UserService);
	private dialogRef = inject<MatDialogRef<MFACodeComponent>>(MatDialogRef);

	isLoading = false;
	mfaCode = "";

	secure(): void {
		if (this.mfaCode.trim() === "") {
			this.toastr.warning(this.translate.instant("users.user.settings.2fa.code.request"));
			return;
		}
		this.isLoading = true;
		this.userService
			.getSecureJwt(this.mfaCode)
			.pipe(
				first(),
				finalize(() => (this.isLoading = false))
			)
			.subscribe({
				next: (result) => {
					if (result["result"]) {
						sessionStorage.setItem("access_token", result["token"]);
						this.toastr.success(this.translate.instant("users.user.settings.2fa.secure.success"));
						this.dialogRef.close(true);
					} else {
						this.toastr.error(this.translate.instant("users.user.settings.2fa.secure.failed"));
					}
				},
				error: () => {
					this.toastr.error(this.translate.instant("users.user.settings.2fa.secure.failed"));
				},
			});
	}

	secureByIp(): void {
		this.isLoading = true;
		this.userService
			.getSecureJwtByIp()
			.pipe(
				first(),
				finalize(() => (this.isLoading = false))
			)
			.subscribe((result) => {
				if (result["result"]) {
					sessionStorage.setItem("access_token", result["token"]);
					this.toastr.success(this.translate.instant("users.user.settings.2fa.secure.success"));
					this.dialogRef.close(true);
				} else {
					this.toastr.error(this.translate.instant("users.user.settings.2fa.secure.failed"));
				}
			});
	}
}
